// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Accordion-components-AccordionGroup-module__AccordionGroup";
export { _1 as "AccordionGroup" }
